var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBypass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#C9007A",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16L23 13L20 10V12H18.748C17.8599 8.54955 14.7277 6 11 6C7.27232 6 4.14012 8.54955 3.25203 12H1V14H5C5 10.6863 7.68629 8 11 8C14.3137 8 17 10.6863 17 14H20V16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14C15 16.2091 13.2092 18 11 18C8.7909 18 7.00004 16.2091 7.00004 14C7.00004 11.7909 8.7909 10 11 10C13.2092 10 15 11.7909 15 14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBypass);
export default __webpack_public_path__ + "static/media/bypass.adaa4082e7513ed9d2f7d07b80801bde.svg";
export { ForwardRef as ReactComponent };